import { render, staticRenderFns } from "./sub-lines.form.vue?vue&type=template&id=5fb089e6&"
import script from "./sub-lines.form.vue?vue&type=script&lang=ts&"
export * from "./sub-lines.form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports